/**
 * Employment Event Actor Types
 */
export const EVENT_ACTOR_TYPES = {
  SYSTEM: 'System',
  USER: 'User',
  IMPORT: 'Import'
};

export const getActorTypeColor = (actorType) => {
  switch (actorType) {
    case EVENT_ACTOR_TYPES.SYSTEM:
      return '#8b5cf6';
    case EVENT_ACTOR_TYPES.USER:
      return '#3b82f6';
    case EVENT_ACTOR_TYPES.IMPORT:
      return '#06b6d4';
    default:
      return '#64748b';
  }
};
